export const preventSelection = (e, value, selection, callback) => {
	if (value === selection) {
		return e.preventDefault();
	} else {
		return callback(value);
	}
};
